// extracted by mini-css-extract-plugin
export default {"layout":"_939e074717 b49424464f _8240828062","h_slide":"_6a203611b7","category":"cab72a4556 _0808355808 _0de8b7644e"};